import Select, { OptionArea, Option as SelectOption, selectAll as selectAllOption } from './Select';
import Group from './SelectGroup';
import Tag from './TagRender';

export const Option = SelectOption;
export const selectAll = selectAllOption;
export const SelectGroup = Group;
export const TagRender = Tag;
export { OptionArea };

export default Select;
